export default "__VITE_ASSET__DB$sTk84__"